module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/2_94d47db002ee35378656c830214708f4.png";